/* tslint:disable */
/* eslint-disable */
export enum WorkVoucherStatusEnum {
  Draft = 'draft',
  Captured = 'captured',
  ApprovalPending = 'approval_pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Posted = 'posted',
  Paid = 'paid',
  Cancelled = 'cancelled'
}
